export const SocialInteractionTargetFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'SocialInteractionTarget' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SocialInteractionTarget' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'urn' },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'commentsCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reactionsCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'sharesCount' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'userReactionType' } },
                ],
            },
        },
    ],
};
//# sourceMappingURL=social-interaction-target.fragment.gql-types.js.map